import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getMyProfile } from '@/api/profile';

const IdentityVerificationPage = () => {
  // Fetch user profile data
  const { data: profileData, isLoading, error } = useQuery({
    queryKey: ['user-profile'],
    queryFn: getMyProfile
  });

  const userProfile = profileData?.data;

  useEffect(() => {
    // Dynamically load the external script
    const script = document.createElement('script');
    script.src = 'https://app.protechidchecker.com/apps/org8426';
    script.async = true;

    // Add script to document head
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  if (isLoading) {
    return (
      <div className='container flex flex-col'>
        <h1>Identity Verification</h1>
        <p>Loading profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className='container flex flex-col'>
        <h1>Identity Verification</h1>
        <p>Error loading profile: {error.message}</p>
      </div>
    );
  }

  return (
    <div className='container flex flex-col'>
      <h1>Identity Verification</h1>
      <h2>{userProfile?.id || 'No ID available'}</h2>
      <h3>{userProfile?.email || 'No email available'}</h3>
      <div className='w-full flex-1' id='protechidchecker'></div>
    </div>
  );
};

export default IdentityVerificationPage;